import React from 'react'
import styled from 'styled-components'
import { TfiReload } from "react-icons/tfi";

// Paleta oscura opcional: solo se aplica cuando se pasa isDark="true".
// Sin ese prop el modal queda idéntico al look claro de siempre (retrocompatible).
const DARK = {
    bg: '#151B23',
    border: '#2A323C',
    text: '#F2F5F8',
    textSecondary: '#8A96A5',
    hover: '#1B222B',
};

const Modal = ({
    children,
    status,
    changeStatus,
    title = 'Alerta',
    showHeader = true,
    showOverlay = true,
    positionModal = 'center',
    padding = '20px',
    action = '',
    width = '450px',
    button = null,
    nameAsigned = '',
    isDark = false,
}) => {
    const dark = isDark === true || isDark === 'true';
    return (
        <>
            {status &&
                <Overlay className="content-modal-major" showOverlay={showOverlay} positionModal={positionModal}>
                    <ModalContent className="content-modal-second" padding={padding} width={width} dark={dark}>
                        { showHeader &&
                            <ModalHeader marginBottom={button} dark={dark}>
                                <h2>{title}</h2>
                                {(button && nameAsigned.length > 0) && (
                                    <div style={{color: nameAsigned === "Sin signar" ? "red" : "#5bc0de", fontSize: "1rem", fontWeight: "800"}}>
                                        {nameAsigned}
                                    </div>
                                )}
                            </ModalHeader>
                        }
                        <ExitButton className="btn-close-modal" onClick={() => {changeStatus(false)}} dark={dark}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-x" viewBox="0 0 16 16">
                                <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
                            </svg>
                        </ExitButton>

                        {children}
                    </ModalContent>
                </Overlay>
            }
        </>
    )
}

export default Modal;

const Overlay = styled.div`
overflow: none;
    width: 100vw;
    height: 100vh;
    position: fixed;
    z-index: 1000;
    top: 0;
    left: 0;
    background: ${props => props.showOverlay ? 'rgba(0,0,0,.5)' : 'rgba(0,0,0,0)'};
    padding: 40px;
    display: flex;
    align-items: ${props => props.positionModal ? props.positionModal : 'center'};
    justify-content: center;
`;

const ModalContent = styled.div`
    width: ${props => props.width ? props.width : '500px'};
    min-height: 100px;
    background: ${props => props.dark ? DARK.bg : '#fff'};
    color: ${props => props.dark ? DARK.text : 'inherit'};
    border: ${props => props.dark ? `1px solid ${DARK.border}` : 'none'};
    position: relative;
    border-radius: 12px;
    box-shadow: ${props => props.dark ? '0 12px 32px rgba(0,0,0,0.4)' : 'rgba(100,100,111, 0.2) 0px 7px 29px 0px'};
    padding: ${props => props.padding ? props.padding : '20px'};

    @media (max-width: 900) {
        width: 100%;
    }
`;

const ModalHeader = styled.div`
    display: flex;
    flex-direction: ${props => props.marginBottom ? 'column' : 'row'};
    align-items: center;
    justify-content: center;
    margin-bottom: ${props => props.marginBottom ? '0px' : '10px'};
    padding-bottom: 10px;
    border-bottom: 1px solid ${props => props.dark ? DARK.border : '#e8e8e8'};
    h2 {
        color: ${props => props.dark ? DARK.text : 'inherit'};
    }
    h3 {
        font-weight: bold;
        font-size: 18px;
        color: ${props => props.dark ? DARK.text : '#455a64'};
    }
`

const ExitButton = styled.button`
  position: absolute;
  top: 15px;
  right: 20px;
  width: 30px;
  height: 30px;
  border: none;
  background: none;
  cursor: pointer;
  transition: .3s ease all;
  border-radius: 5px;
  color: ${props => props.dark ? DARK.textSecondary : '#455a64'};
  &:hover {
      background: ${props => props.dark ? DARK.hover : '#f2f2f2'};
  }
  svg {
      width: 100%;
      height: 100%;
  }
`